<template>
    <div>
        <v-card class="mb-4">
            <v-card-title>Dashboard</v-card-title>
            <v-card-text>
                <p class="font-weight-regular">
                    Selamat datang di APLIKASI JURNAL MENGAJAR {{ $root.app.name.toUpperCase() }}.
                    <br />
                    Untuk bantuan silahkan hubungi tim <a href="https://izzaalfiansyah.vercel.app" target="_blank">kami</a>
                </p>
            </v-card-text>
        </v-card>
        <v-card class="mb-4">
            <v-card-title>Grafik Kehadiran Siswa</v-card-title>
            <v-card-text>
                <canvas id="grafik-kehadiran-siswa" ref="canvasKehadiranSiswa"></canvas>
            </v-card-text>
        </v-card>
        <!-- <v-card>
            <v-card-title>Grafik Jurnal Guru</v-card-title>
        </v-card> -->
    </div>
</template>

<script>
import Chart from "chart.js";

export default {
    layout: 'default',
    mounted() {
        this.renderChart();
    },
    methods: {
        async renderChart() {
            const ctx = this.$refs.canvasKehadiranSiswa;

            const res = await this.$root.app.http.get('/api/grafik/kehadiran-siswa?tanggal=2023-09-06');
            let total = {};

            if (res.error) {
                this.$root.app.notif(res.message, true);
            } else {
                res.status.forEach((item) => {
                    total[item] = 0;
                });

                res.data.forEach((item) => {
                    res.status.forEach((status) => {
                        total[status] += item.kehadiran_siswa[status];
                    });
                });
            }

            const labels = res.status;

            let data = [];
            labels.forEach((item) => {
                data.push(total[item]);
            });

            var myChart = new Chart(ctx, {
                type: 'doughnut',
                data: {
                    labels: labels,
                    datasets: [{
                        label: 'Siswa',
                        data: data,
                        backgroundColor: [
                            'rgba(255, 99, 132, 1)',
                            'rgba(54, 162, 235, 1)',
                            'rgba(255, 206, 86, 1)',
                            'rgba(75, 192, 192, 1)',
                            'rgba(153, 102, 255, 1)',
                            'rgba(255, 159, 64, 1)'
                        ],
                    }]
                },
                options: {
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true
                            }
                        }]
                    }
                }
            });
        }
    }
};
</script>
